module.exports = __webpack_public_path__ + "img/Assets-Award-02.32002a1a.png";